import {
  TabComponent,
  TabItemDirective,
  TabItemsDirective,
} from '@syncfusion/ej2-react-navigations';
import GlobalFilterComponent from '../../../../components/GlobalFilterComponent';
const columns = [
  { field: 'name', Text: 'name' },
  { field: 'description', Text: 'description' },
  { field: 'alias', Text: 'alias' },
];
const WorkordersFilterTabs = () => {
  const ERP_TYPE = process.env.REACT_APP_ERP_TYPE;
  const begin = (args: any) => {
    if (args.isSwiped) {
      args.cancel = true;
    }
  };
  return (
    <div className='main-content-order-request'>
      <TabComponent
        enablePersistence={true}
        selecting={begin.bind(this)}
        statelessTemplates={['directiveTemplates']}
      >
        <TabItemsDirective>
          {
            ERP_TYPE === 'PRONTO' &&(
              <TabItemDirective
              header={{ text: 'Responsibility' }}
              content={() => (
                <>
                  <GlobalFilterComponent
                    columns={columns}
                    query={'workorders$responsibility'}
                  />
                </>
              )}
            />
            )
          }      
          <TabItemDirective
            header={{ text: 'Status' }}
            content={() => (
              <>
                <GlobalFilterComponent
                  columns={columns}
                  query={'workorders$status'}
                />
              </>
            )}
          />
          <TabItemDirective
            header={{ text: 'Type' }}
            content={() => (
              <>
                <GlobalFilterComponent
                  columns={columns}
                  query={'workorders$type'}
                />
              </>
            )}
          />
          <TabItemDirective
            header={{ text: 'Priority' }}
            content={() => (
              <>
                <GlobalFilterComponent
                  columns={columns}
                  query={'workorders$priority'}
                />
              </>
            )}
          />
           <TabItemDirective
            header={{ text: 'Department' }}
            content={() => (
              <>
                <GlobalFilterComponent
                  columns={columns}
                  query={'workorders$department'}
                />
              </>
            )}
          />
          {
            ERP_TYPE === 'PRONTO' &&(
              <TabItemDirective
              header={{ text: 'Section' }}
              content={() => (
                <>
                  <GlobalFilterComponent
                    columns={columns}
                    query={'workorders$section'}
                  />
                </>
              )}
            />
            )
          }
          {
            ERP_TYPE === 'PRONTO' &&(
              <TabItemDirective
              header={{ text: 'Reason' }}
              content={() => (
                <>
                  <GlobalFilterComponent
                    columns={columns}
                    query={'workorders$reason'}
                  />
                </>
              )}
            />
            )
          }
          {
            ERP_TYPE === 'PRONTO' &&(
              <TabItemDirective
              header={{ text: 'Reference' }}
              content={() => (
                <>
                  <GlobalFilterComponent
                    columns={columns}
                    query={'workorders$reference'}
                  />
                </>
              )}
            />
            )
          }
        </TabItemsDirective> 
      </TabComponent>
    </div>
  );
};

export default WorkordersFilterTabs;
